import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { MainApp } from '../app/MainApp';
import { LoginPage } from '../pages/LoginPage';
import { useStorage } from '../contexts/StorageContext';

/** 비로그인 전용 — 로그인 상태면 /로 리다이렉트 */
const PublicRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isLoggedIn } = useStorage();
  return isLoggedIn ? <Navigate to="/" replace /> : <>{children}</>;
};

/** 로그인 전용 — 비로그인 상태면 /login으로 리다이렉트 */
const PrivateRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isLoggedIn } = useStorage();
  return isLoggedIn ? <>{children}</> : <Navigate to="/login" replace />;
};

/**
 * 앱 라우터.
 * 로그인 후 / 경로는 MainApp 으로 연결된다.
 * MainApp 내부에서 사이드바로 DailyWorkflowPage / CardListPage 를 전환한다.
 */
export const AppRouter: React.FC = () => (
  <BrowserRouter>
    <Routes>
      <Route path="/login"  element={<PublicRoute><LoginPage /></PublicRoute>} />
      <Route path="/"       element={<PrivateRoute><MainApp /></PrivateRoute>} />
      <Route path="*"       element={<Navigate to="/" replace />} />
    </Routes>
  </BrowserRouter>
);